<template>
    <div class="pricing">
        <div class="annual" v-if="yearly">
          <div>
            <div v-if="comboDiscount" class="combo">SAVE ${{ Number(comboDiscount).toFixed(2) }}</div>
          </div>
            ${{ Number(yearly).toFixed(2) }}/year billed annually
        </div>
        <div class="annual" v-else-if="oneTime">
            ${{ oneTime }} one time payment
        </div>
        <div class="annual" v-else>
            Contact Us: 1-877-714-5001
        </div>
        <div class="explanation">Ends up costing:</div>
        <div class="price">
            <template v-if="monthly" >
                <div class="dollars">${{ monthly }}</div>
                <div class="per">per month</div>
            </template>
            <template v-else-if="oneTime">
                <div v-if="oneTime" class="dollars">${{ oneTime }}</div>
            </template>
            <template v-else>
                <div class="dollars missing">-</div>
                <div class="per">per month</div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LibPricingWidget',
    props: ['yearly', 'oneTime', 'comboDiscount'],
    data() {
        return {
            open: false,
        };
    },
    methods: {
        select(index) {
            this.open = false;
            this.$emit('input', index);
        },
    },
    computed: {
        monthly() {
            return this.yearly ? Math.ceil(this.yearly / 12) : null;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../src/scss/prelude";

.pricing {
    .annual {
        height: 43px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 30px;
        color: $bluegray;
        font-size: 22px;
        font-weight: 900;

        .combo {
            display: inline-block;
            margin-bottom: 5px;
            font-size: 16px;
            color: $black;
            font-weight: normal;
            background-color: #D82638;
            color: white;
            padding: 4px 6px;
            border-radius: 3px;
            font-weight: bold;
        }
    }

    .explanation {
        margin-bottom: 5px;
        font-size: 9px;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 1.35px;
        color: $darkgray;
    }

    .price {
        margin-bottom: 30px;

        .dollars {
            font-size: 52px;
            font-weight: 900;

            &.missing {
                width: 80px;
                text-align: center;
            }
        }

        .per {
            margin-left: 5px;
            color: $darkgray;
        }

        div {
            display: inline-block;
        }
    }
}
</style>